module.exports = __webpack_public_path__ + "static/media/signin.17dc7748.svg";